module.exports = __webpack_public_path__ + "img/ck1.32ecea8f.png";